/**
 * Admin "my specialist isn't listed" leads (M14-T09 + T13). amtc_admin only.
 * Kept a separate module from procedure leads (different endpoint, fields) — the
 * Leads page unifies the VIEW, not the schema.
 */
import { apiFetch, type CappedList } from './client'

export type AdminSpecialistLead = {
  id: string
  reference: string
  description: string
  details: string | null
  area: string | null
  patient_name: string | null
  patient_phone: string | null
  status: string
  concierge_notes: string | null
  created_at: string
}

export const SPECIALIST_LEADS_KEY = ['admin', 'specialist-requests'] as const

/** GET /api/v1/admin/specialist-requests — newest first, optional ?status=. */
export async function fetchSpecialistLeads(
  token: string | null,
  status?: string | null,
  q?: string,
): Promise<CappedList<AdminSpecialistLead>> {
  const params = new URLSearchParams()
  if (status) params.set('status', status)
  if (q) params.set('q', q)
  const qs = params.toString() ? `?${params.toString()}` : ''
  return await apiFetch<CappedList<AdminSpecialistLead>>(
    `/api/v1/admin/specialist-requests${qs}`,
    { token },
  )
}

/** PATCH /api/v1/admin/specialist-requests/{ref} — set status + notes. */
export async function updateSpecialistLead(
  token: string | null,
  reference: string,
  input: { status: string; concierge_notes?: string },
): Promise<void> {
  await apiFetch(`/api/v1/admin/specialist-requests/${reference}`, {
    method: 'PATCH',
    token,
    body: {
      status: input.status,
      ...(input.concierge_notes !== undefined
        ? { concierge_notes: input.concierge_notes }
        : {}),
    },
  })
}
